// extracted by mini-css-extract-plugin
export default {"wrapper":"Menu_wrapper__HTAjK","group":"Menu_group__OOVJj","title":"Menu_title__0M0cc","menu":"Menu_menu__3GVTX","menuItem":"Menu_menuItem__mwtYB"};